import { XStack, YStack, View, Text } from "tamagui";
import { RiPhoneLine } from "react-icons/ri";
import { colors } from "@styles/colors";
import type { PaymentMethodDetailData } from "./methodTypes";

interface MethodCardVisualProps {
  data: PaymentMethodDetailData;
}

/** 詳細頁 Header 內的卡面視覺：信用卡卡面 / 電子錢包 banner（透明底，疊在漸層上） */
export default function MethodCardVisual({ data }: MethodCardVisualProps) {
  if (data.kind === "card") {
    return (
      <YStack
        br={16}
        px="$4"
        py="$4"
        bw={1}
        bc="rgba(255,255,255,0.22)"
        mih={140}
        style={{ boxShadow: "inset 0 1px 0 rgba(255,255,255,0.3)" }}>
        <XStack jc="space-between" ai="flex-start" mb="$6">
          <YStack>
            <Text fontSize={10} fontWeight="700" color="rgba(255,255,255,0.85)" ls={1} mb="$1">
              {data.bank ?? "BANK"}
            </Text>
            <Text fontSize={13} fontWeight="700" color={colors.light}>
              {data.fullName ?? data.name}
            </Text>
          </YStack>
          {/* 晶片 */}
          <View w={32} h={24} br={4} background="linear-gradient(135deg, #FBBF24, #D97706)" />
        </XStack>

        <Text fontSize={18} fontWeight="700" color={colors.light} mb="$3" fontFamily="monospace" ls={2}>
          {data.cardNumber ?? "•••• •••• •••• ••••"}
        </Text>

        <XStack jc="space-between" ai="flex-end">
          <YStack>
            <Text fontSize={9} fontWeight="700" color="rgba(255,255,255,0.7)" ls={1}>
              持卡人
            </Text>
            <Text fontSize={12} fontWeight="600" color={colors.light} mt="$0.5">
              {data.holder ?? "—"}
            </Text>
          </YStack>
          <YStack>
            <Text fontSize={9} fontWeight="700" color="rgba(255,255,255,0.7)" ls={1}>
              有效期限
            </Text>
            <Text fontSize={12} fontWeight="600" color={colors.light} mt="$0.5" style={{ fontVariantNumeric: "tabular-nums" }}>
              {data.expiry ?? "--/--"}
            </Text>
          </YStack>
          <Text fontSize={18} fontWeight="800" color={colors.light} fontStyle="italic">
            {data.network ?? ""}
          </Text>
        </XStack>
      </YStack>
    );
  }

  // 電子錢包 banner
  return (
    <XStack
      br={16}
      px="$4"
      py="$5"
      ai="center"
      gap="$3.5"
      bw={1}
      bc="rgba(255,255,255,0.22)"
      style={{ boxShadow: "inset 0 1px 0 rgba(255,255,255,0.3)" }}>
      <View w={56} h={56} br={14} bg={data.color ?? colors.primary} ai="center" jc="center" flexShrink={0}>
        <Text fontSize={28} fontWeight="800" color={colors.light}>
          {data.iconText ?? data.name.charAt(0)}
        </Text>
      </View>
      <YStack f={1} miw={0}>
        <Text fontSize={18} fontWeight="800" color={colors.light} mb="$1">
          {data.fullName ?? data.name}
        </Text>
        <XStack ai="center" gap="$1.5">
          <RiPhoneLine size={11} color="rgba(255,255,255,0.85)" />
          <Text fontSize={12} color="rgba(255,255,255,0.85)">
            {data.bindPhone ?? "—"}
          </Text>
        </XStack>
      </YStack>
    </XStack>
  );
}
